import React, {useContext, useEffect} from "react";
import config from "./../../api/config";

import {Avatar, Card, DatePicker, Flex, Input, Switch, Table} from 'antd';
import {CheckCircleOutlined, DollarOutlined, IssuesCloseOutlined, StopOutlined} from "@ant-design/icons";
import useAuth from "../../hooks/useAuth";
import { Modal, notification } from 'antd';
import ModalForm from '../main/Modal';
import Button from "../element/Button";
import RequestApi from "../../api/RequestApi";

const OrderDetailUser = ({item, reload}) => {

    const { user, setUser, roles }  = useAuth();
    const [dataSource, setDataSource] = React.useState([]);
    const [actions, setActions] = React.useState([]);
    const [isOpenPayment, setOpenPayment] = React.useState(false);
    const [inputDatePayment, setInputDatePayment ] = React.useState('');
    const [inputCommentPayment, setInputCommentPayment ] = React.useState('');
    const [apiNotification, contextHolder] = notification.useNotification();


    const columns = [
        {
            title: 'Список курсов',
            responsive: ['xs'],
            render: (item) => {
                return <div>
                    <div><span className={'font-bold'}>Код: </span>{item.code}</div>
                    <div>{item.name}</div>
                    <div><span className={'font-bold'}>Стоимость: </span>{item.price} руб.</div>
                    <div><span className={'font-bold'}>Доступ: </span>{item.access}</div>
                </div>
            }
        },
        {
            title: 'Код',
            width: 100,
            dataIndex: 'code',
            responsive: ['md'],
        },
        {
            title: 'Название',
            dataIndex: 'name',
            responsive: ['md'],
        },
        {
            title: 'Стоимость',
            width: 200,
            dataIndex: 'price',
            responsive: ['md'],
        },
        {
            title: 'Доступ',
            width: 200,
            dataIndex: 'access',
            responsive: ['md'],
        }
    ];

    const onPaymentProcess = () => {
        window.location.href = config.host + '/order/payment/form/' + item.id;
    }

    const onSetPayment = () => {
        setOpenPayment(true);
    }

    const onSetPaymentConfirm = () => {
        RequestApi.post('private/order/' + item.id + '/payment', {
            dt: inputDatePayment,
            comment: inputCommentPayment
        }).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                reload();
            } else {
                let errorMessages = data.error.messages;
                if (data.error.fields.comment) {
                    errorMessages.push('Заполните поле комментарий');
                }
                apiNotification['error']({
                    message: 'Ошибка установки оплаты',
                    description: data.error.messages.join(' '),
                });
            }
        });
    }

    const onCancelPayment = () => {
        Modal.confirm({
            title: 'Подтвердите отмену оплаты',
            content: 'Вы действительно хотите отменить оплату? Если оплату отменить, то все доступы по заказу будут удалены.',
            footer: (_, { OkBtn, CancelBtn }) => (
                <div className={'flex'}>
                    <div className={'pr-2'}>
                        <Button text={'Отмена'} onClick={() => {Modal.destroyAll()}}/>
                    </div>
                    <Button text={'Подтверждаю'} onClick={() => onCancelPaymentConfirm()} type={'primary'}/>
                </div>
            ),
        });
    }

    const onCancelPaymentConfirm = () => {
        RequestApi.get('private/order/' + item.id + '/cancel-payment').then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                reload();
                Modal.destroyAll();
            }
        });
    }

    const onCancelOrder = () => {
        Modal.confirm({
            title: 'Подтвердите отмену заказа',
            content: 'Вы действительно хотите отменить заказ? Если заказ отменить, то все доступы по заказу будут удалены.',
            footer: (_, { OkBtn, CancelBtn }) => (
                <div className={'flex'}>
                    <div className={'pr-2'}>
                        <Button text={'Отмена'} onClick={() => {Modal.destroyAll()}}/>
                    </div>
                    <Button text={'Подтверждаю'} onClick={() => onCancelOrderConfirm()} type={'primary'}/>
                </div>
            ),
        });
    }
    const onCancelOrderConfirm = () => {
        RequestApi.get('private/order/' + item.id + '/cancel').then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                reload();
                Modal.destroyAll();
            }
        });
    }

    const onChangeDatePayment = (date, dateString) => {
        setInputDatePayment(dateString);
    }

    useEffect(() => {
        setDataSource(item.cart);

        //inputRoles.includes('ROLE_ADMIN')
        let actionsList = [];

        // Если админ
        // если не оплачено
        if ((roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && !item.is_cancelled && !item.is_payment) {
            actionsList.push(<div style={{color: 'green'}} onClick={onSetPayment}><CheckCircleOutlined /> Установить оплату</div>);
        }
        // если оплачено
        if ((roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && item.is_payment) {
            actionsList.push(<div onClick={onCancelPayment}><IssuesCloseOutlined /> Снять оплату</div>);
        }
        // если заказ не отменен
        if ((roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER') || roles.includes('ROLE_PARTNER')) && !item.is_cancelled) {
            actionsList.push(<div onClick={onCancelOrder} style={{color: 'red'}}><StopOutlined /> Отменить заказ</div>);
        }

        // Если клиент
        // если не оплачено
        if (!roles.includes('ROLE_ADMIN') && !roles.includes('ROLE_MANAGER') && !roles.includes('ROLE_PARTNER') && !item.is_payment) {
            actionsList.push(<div onClick={onPaymentProcess} style={{color: 'green'}}><DollarOutlined /> Оплатить заказ</div>);
        }
        // если заказ не отменен и еще не оплачен
        if (!roles.includes('ROLE_ADMIN') && !roles.includes('ROLE_MANAGER') && !roles.includes('ROLE_PARTNER') && !item.is_cancelled && !item.is_payment) {
            actionsList.push(<div onClick={onCancelOrder} style={{color: 'red'}}><StopOutlined /> Отменить заказ</div>);
        }

        setActions(actionsList);

    }, []);

    return <>
        {contextHolder}
        <Card
            actions={actions}>
            <Card.Meta
                title={'Заказ #' + item.id}
                description={
                    <>
                        <div className={'flex mob-block'}>
                            <p>Дата заказа: <b>{item.dt}</b></p>
                            <p className={"pl-4 mob-pl-0 "}>Сумма заказа: <b>{item.price} руб.</b></p>
                            <p className={"pl-4 mob-pl-0 "}>Статус оплаты: <b>{
                                item.is_payment ? 'Оплачено ' + item.payment_dt : 'Не оплачено'
                            }</b></p>
                        </div>
                        <Table className={"mt-3"}
                               bordered
                               columns={columns}
                               dataSource={dataSource}
                               pagination={false}
                        />
                    </>
                }
            />
        </Card>
        <Modal
            title="Установить оплату"
            open={isOpenPayment} onOk={onSetPaymentConfirm} onCancel={() => setOpenPayment(false)}
            footer={(_, { OkBtn, CancelBtn }) => (
                <div className={'flex'}>
                    <div className={'w-6/12 pr-2'}>
                        <Button text={'Отмена'} onClick={() => setOpenPayment(false)}/>
                    </div>
                    <div className={'w-6/12'}>
                        <Button text={'Подтвердить'} onClick={() => onSetPaymentConfirm()} type={'primary'}/>
                    </div>
                </div>
            )}
        >
           <div className={'flex'}>
               <div className={'w-5/12 pr-2'}>
                   <DatePicker showTime={{format: 'HH:mm'}} format={'DD.MM.YYYY HH:mm'} style={{width: '100%'}} onChange={onChangeDatePayment}/>
               </div>
               <div className={'w-7/12'}>
                   <Input value={inputCommentPayment} onChange={(e) => setInputCommentPayment(e.target.value)} placeholder={'Введите комментарий'}/>
               </div>
           </div>
        </Modal>
    </>

}

export default OrderDetailUser;
